import React, {Component, useState} from 'react';
import css from './Input.module.scss';
import PropTypes from 'prop-types';
import {withTranslation} from "../../../i18n";
import InputError from "../../../components/common/input-error/InputError";

const namespacesRequired = ['common'];

const Input = (props) => {

  Input.propTypes = {
    inputId: PropTypes.string.isRequired,
    inputLabel: PropTypes.string,
    inputName: PropTypes.string.isRequired,
    inputType: PropTypes.string,
    inputPlaceholder: PropTypes.string
  };

  Input.defaultProps = {
    inputId: 'addAnId',
    inputLabel: 'Input desc :',
    inputName: 'addName',
    inputType: 'text',
    inputPlaceholder: 'Write Something'
  };


  return (<div className={css.input__wrapper}>


    <label htmlFor={props.inputId}
           className={css.label}
    >
      {props.inputLabel}
    </label>

    <input type={props.inputType}
           name={props.inputName}
           id={props.inputId}
           placeholder={props.inputPlaceholder}
           className={`${css.input}`}
           value={props.value}
           onChange={props.onChange}
           maxLength={props.maxLength}
           onBlur={props.onBlur}
           disabled={props.disabled}
           readOnly={props.readOnly}
           autoComplete={props.autocomplete}
           ref={props.anchorRef}

    />

    {!props.hideErrors && (<InputError name={props.inputName}/>)}

  </div>);
};

export default withTranslation(namespacesRequired)(Input);

